//-------------------------------------------------------------------------------------------------- Includes
import { useCallback, useEffect, useState } from "react";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import ListNotificationsComponent from "./components/ListNotificationsComponent";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../stores/store";
import { getGeneralData, setReadNotification } from "../../stores/slices/generalDataSlice";
import { RequestUpdateMessage, ResponseMessages } from "../../types/common";
import NotificationDescription from "./components/NotificationDescription";
import { updateNotification } from "../../methods/Methods";

//-------------------------------------------------------------------------------------------------- View
const Notifications = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedContract } = useSelector(getGeneralData);
    // Control
    const [viewNotification, setViewNotification] = useState<boolean>(false);
    // Data
    const [clientId, setClientId] = useState<string>("");
    const [notifications, setNotifications] = useState<Array<ResponseMessages>>([]);
    const [notificationSelected, setNotificationSelected] = useState<ResponseMessages>();
    const [customBreadcrumb, setCustomBreadcrumb] = useState<string>();

    const readNotification = useCallback(async (notification: ResponseMessages) => {
        const request: RequestUpdateMessage = {
            id_message: notification.id_message
        };

        await updateNotification(request, clientId)
            .then((response) => {
                if (response.data && response.data[0].status === true) {
                    dispatch(setReadNotification(notification.id_message));
                }
            })
            .catch(() => { });
    }, [dispatch, clientId]);

    const handlePressElement = useCallback((element: ResponseMessages) => {
        setNotificationSelected(element);
        readNotification(element);
        setViewNotification(true);
    }, [setViewNotification, setNotificationSelected, readNotification]);

    useEffect(() => {
        if (selectedContract && selectedContract.notifications) {
            setClientId(selectedContract.sucursal + selectedContract.suscriptor);
            setNotifications(selectedContract.notifications);
        }
    }, [selectedContract, setClientId]);

    useEffect(() => {
        if (viewNotification) {
            setCustomBreadcrumb("Notificaciones / Detalles");
        }
        else {
            setCustomBreadcrumb(undefined);
        }
    }, [viewNotification]);

    return (
        <SubDefaultLayout
            title={(viewNotification) ? "Notificación" : "Notificaciones"}
            needReturn={viewNotification}
            functionReturn={() => setViewNotification(false)}
            customBreadcrumb={customBreadcrumb}
            customBreadcrumbTo="/notifications"
        >
            {
                viewNotification && notificationSelected ?
                    <NotificationDescription notification={notificationSelected} />
                    :
                    <ListNotificationsComponent
                        notifications={notifications}
                        onClickElement={handlePressElement}
                    />
            }
        </SubDefaultLayout>
    );
};

//-------------------------------------------------------------------------------------------------- Exports
export default Notifications;
